import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetEigeneAuftraegeMutation } from '../../api/AuftragAPI';
import { useGetAuftragMessagesListeMutation } from '../../api/AuftragMessagesAPI';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';
import { IAuftragAgAnsicht } from '../../types/Types';
import EigeneAuftraegeListe from '../eigeneauftraege/EigeneAuftraegeListe';

export default function LandingPageAuftraggeber() {

    //const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [eigeneauftraegeAPI] = useGetEigeneAuftraegeMutation();
    const [getChatListe] = useGetAuftragMessagesListeMutation();

    const [auftraege, setAuftraege] = useState<IAuftragAgAnsicht[]>([]);
    const [anzahlNeueNachrichten, setAnzahlNeueNachrichten] = useState<number>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const lade = () => {
        setIsLoading(true);
        eigeneauftraegeAPI().unwrap()
            .then((data) => setAuftraege(data))
            .catch((error) => console.log(error))
            .finally(() => setIsLoading(false))
            ;

    }

    useEffect(() => {
        lade();
    }, []);

    return (
        <>
            <div className="container">

                <LoadingModal show={isLoading} />

                <div style={{ alignItems: "end", display: "flex", justifyContent: "end" }}>

                    <button onClick={() => navigate("/neuerauftrag")}
                        style={{ marginBottom: "20px", alignItems: "end" }}
                        className=' btn btn-outline-primary'
                    >
                        <i className='bi bi-plus'></i>&nbsp;Neuen Auftrag anlegen
                    </button>

                </div>

                <h3>{t('deTranslation.eigeneAuftraege.titel')}</h3>


                <EigeneAuftraegeListe originalListe={auftraege} statusChanged={() => { }} />


            </div>

        </>
    );
}
